export default __webpack_public_path__ + "static/media/tunnelRescue.bff28b67.jpg";